import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PlayCircle, CheckCircle, BookOpen } from "@phosphor-icons/react";

export default function MyCourses() {
  const [enrs, setEnrs] = useState([]);
  useEffect(() => { api.get("/enrollments").then((r) => setEnrs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-display text-3xl font-800 tracking-tight mb-1">Mis Cursos</h1>
      <p className="text-muted-foreground mb-8">Todos tus cursos comprados y asignados.</p>
      {enrs.length === 0 ? (
        <div className="bg-white border border-border rounded-lg p-12 text-center" data-testid="mycourses-empty">
          <BookOpen size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground mb-4">Aún no tienes cursos.</p>
          <Link to="/catalogo"><Button className="bg-primary text-white hover:bg-blue-600">Explorar catálogo</Button></Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {enrs.map((e) => (
            <div key={e.id} className="bg-white border border-border rounded-lg overflow-hidden" data-testid={`mycourse-${e.course_id}`}>
              <div className="aspect-video bg-secondary overflow-hidden relative">
                <img src={e.course?.image_url} alt="" className="w-full h-full object-cover" />
                {e.passed && <Badge className="absolute top-3 right-3 bg-primary text-white gap-1"><CheckCircle size={13} weight="fill" /> Aprobado</Badge>}
              </div>
              <div className="p-5">
                <h3 className="font-display font-700 tracking-tight line-clamp-2">{e.course_title}</h3>
                <Progress value={e.progress_pct} className="h-2 mt-3" />
                <div className="flex items-center justify-between mt-2 text-sm text-muted-foreground">
                  <span>{e.progress_pct}% avance</span>
                  {e.grade != null && <span>Nota: <b className={e.passed ? "text-primary" : ""}>{e.grade}</b></span>}
                </div>
                <Link to={`/dashboard/curso/${e.course_id}`}>
                  <Button className="w-full mt-4 bg-primary hover:bg-blue-600 text-white gap-2" data-testid={`open-course-${e.course_id}`}>
                    <PlayCircle size={18} weight="fill" /> {e.passed ? "Repasar" : "Continuar"}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
